import {
    ResolverFn,
    ResolverContext,
    MutationMarkConversationAsReadArgs,
    MarkConversationAsReadResult,
} from 'owa-graph-schema';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import itemId from 'owa-service/lib/factory/itemId';
import folderId from 'owa-service/lib/factory/folderId';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import handleServerResponseSuccessAndError from 'owa-service-utils/lib/handleServerResponseSuccessAndError';
import applyConversationActionService from '../services/applyConversationActionService';

export const markConversationAsReadWeb: ResolverFn<
    MarkConversationAsReadResult,
    any,
    any,
    MutationMarkConversationAsReadArgs
> = async (
    parent: any,
    args: MutationMarkConversationAsReadArgs,
    context: ResolverContext,
    info: any
): Promise<MarkConversationAsReadResult> => {
    const options = args.options.actionOptions;
    const contextFolderId = options.folderId
        ? targetFolderId({
              BaseFolderId: folderId({ Id: options.folderId }),
          })
        : undefined;
    const conversationActions = options.conversations.map(conversation =>
        conversationAction({
            Action: 'SetReadState',
            ConversationId: itemId({ Id: conversation.id }),
            IsRead: args.options.isRead,
            ConversationLastSyncTime: conversation.messagesAsOf ?? undefined,
            SuppressReadReceipts: true,
            ContextFolderId: contextFolderId,
        })
    );

    const requestBody = applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });

    const response = await applyConversationActionService(
        requestBody,
        options.mailboxInfo,
        'markAsReadConversationWeb'
    );

    return handleServerResponseSuccessAndError(response?.Body?.ResponseMessages?.Items).then(() => {
        return {
            __typename: 'MarkConversationAsReadResult',
            success: true,
        };
    });
};
